<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/report/dailyStatement")
          i.fa.fa-chart-line
          span.ml-1 {{ $t("ui.daily_statement") }}
      b-breadcrumb-item
        router-link(to="/report/ticketWalletTransList")
          i.fa.fa-chart-line
          span.ml-1 {{ $t("ui.ticket_list") }}
  div.row
    div.col-md-12
      div.card
        div.card-body
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width="3%")
                        span #
                      th.sticky-position(width="8%")
                        span(:title="$t('ui.ticket_id')") {{ $t('ui.ticket_id') }}
                      th.sticky-position(width="11%")
                        span(:title="$t('ui.member_id')") {{ $t('ui.member_id') }}
                      th.sticky-position(width="11%")
                        span(:title="$t('ui.member_id')") {{ $t('ui.type') }}
                      th.sticky-position(width="11%")
                        span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                      th.sticky-position(width="11%")
                        span(:title="$t('ui.bonus_amount')") {{ $t('ui.bonus_amount') }}
                      th.sticky-position(width="11%")
                        span(:title="$t('ui.status')") {{ $t('ui.status') }}
                      th.sticky-position(width="17%")
                        span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
                      th.sticky-position(width="13%")
                        span(:title="$t('ui.ticket_date')") {{ $t("ui.ticket_date") }}
                      th.sticky-position(width="15%")
                        span(:title="$t('ui.balance_before')") {{ $t('ui.balance_before') }}
                      th.sticky-position(width="14%")
                        span(:title="$t('ui.transfer_amount')") {{ $t('ui.transfer_amount') }}
                      th.sticky-position(width="15%")
                        span(:title="$t('ui.balance_after')") {{ $t('ui.balance_after') }}
                      th.sticky-position.text-right(width="13%")
                        span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                  tbody.clusterize-content
                    tr(v-if="ticketWalletTransList.length == 0")
                      td(colspan="13").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in ticketWalletTransList")
                      td
                        span(:title="index + 1") {{ index + 1 }}
                      td
                        span(:title="item.ticket_id") {{ item.ticket_id }}
                      td
                        span(:title="item.member_id") {{ item.member_id }}
                      td
                        span(:title="item.request_type") {{ item.request_type }}
                      td
                        span.font-weight-bold(:class="$helpers.fontClassName(item.ticket_amount)" :title="$n(item.ticket_amount, 'currency')") {{ $n(item.ticket_amount, 'currency') }}
                      td
                        span.font-weight-bold(:class="$helpers.fontClassName(item.bonus_amount)" :title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                      td
                        span.font-weight-bold.text-info(v-if="item.status.trim().toUpperCase() == 'PENDING'") {{ item.status.trim().toUpperCase() }}
                        span.font-weight-bold.text-success(v-if="item.status.trim().toUpperCase() == 'PROCESSED'") {{ item.status.trim().toUpperCase() }}
                        span.font-weight-bold.text-danger(v-if="item.status.trim().toUpperCase() == 'REJECTED'") {{ item.status.trim().toUpperCase() }}
                        span.font-weight-bold.text-primary(v-if="item.status.trim().toUpperCase() == 'PROCESSING'") {{ item.status.trim().toUpperCase() }}
                      td
                        span(:title="item.remark") {{ item.remark }}
                      td
                        span(:title="$moment(item.ticket_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.ticket_date") {{ $moment(item.ticket_date).format('YYYY-MM-DD, HH:mm:ss') }}
                      td
                        span.font-weight-bold(:class="$helpers.fontClassName(item.balance_before)" :title="$n(item.balance_before, 'currency')") {{ $n(item.balance_before, 'currency') }}
                      td
                        span.font-weight-bold(:class="$helpers.fontClassName(item.transfer_amount)" :title="$n(item.transfer_amount, 'currency')") {{ $n(item.transfer_amount, 'currency') }}
                      td
                        span.font-weight-bold(:class="$helpers.fontClassName(item.balance_after)" :title="$n(item.balance_after, 'currency')") {{ $n(item.balance_after, 'currency') }}
                      td.text-right
                        span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.created_date") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    ticketWalletTransList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    working_date: null,
    request_type: '',
    member_id: ''
  }),
  computed: {
  },
  mounted: function() {
    if (this.$store.getters.ticketWalletTransList.working_date) {
      this.working_date = this.$store.getters.ticketWalletTransList.working_date;
    } else {
      this.working_date = this.$moment(new Date).format('YYYY-MM-DD');
    }

    if (this.$store.getters.ticketWalletTransList.member_id && this.$store.getters.ticketWalletTransList.request_type) {
      this.member_id = this.$store.getters.ticketWalletTransList.member_id;
      this.request_type = this.$store.getters.ticketWalletTransList.request_type;
      this.getAuditList();
    }
  },
  methods: {
    getAuditList: function() {
      let url = config.auditTicketWalletTransUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        working_date: this.working_date,
        member_id: this.member_id,
        request_type: this.request_type
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ticketWalletTransList = response.data.dt;
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>